module.exports = __webpack_public_path__ + "img/namibia.c5e062fc.svg";